import { useEffect, useState } from 'react'

import { timer } from '../../../lib/timer'
import { useVisitsContext } from '../../Visits/hooks/useVisitsContext'

export interface TimerHookState {
    duration: number
}

export const useTimer = (visitId: string, initialDuration: number, isPaused: boolean = true): TimerHookState => {

    const [duration, setDuration] = useState<number>(initialDuration)
    const { updateDuration } = useVisitsContext().visits

    useEffect(() => {

        const subscription = timer.getObservable().subscribe((seconds) => {
            setDuration(seconds)
        })

        return () => {
            // Unsubscribe from timer observable
            subscription.unsubscribe()

            // Update visit duration in memory
            const _duration = timer.getSeconds()
            
            if (_duration !== initialDuration) {
                updateDuration(visitId, _duration)
            }
            
            // Reset the timer back to 0
            timer.reset()
        }
    }, [visitId, updateDuration, initialDuration])
    
    useEffect(() => {
        
        // If recording is paused, pause the timer and update visit duration in memory
        if (isPaused) {
            const _duration = timer.getSeconds()
            timer.pause(_duration || initialDuration)
            return
        }
        
        // If recording is not paused, get the timer continue ticking
        timer.tick(timer.getSeconds() || initialDuration)
    }, [visitId, initialDuration, isPaused, updateDuration])

    return {
        duration
    }
}
